(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["SHOP-PRINCIPAL"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-seccion-id]').forEach(function(seccion) {
      if (seccion.dataset.landingIniciada === 'true') return;
      seccion.dataset.landingIniciada = 'true';

      var imagenPrincipal = seccion.querySelector('[data-imagen-principal]');
      var imagenBadge = seccion.querySelector('[data-imagen-badge]');
      var thumbnailsWrapper = seccion.querySelector('[data-thumbnails]');
      var thumbnails = Array.prototype.slice.call(seccion.querySelectorAll('[data-thumbnail]'));
      var flechaIzq = seccion.querySelector('[data-flecha-izq]');
      var flechaDer = seccion.querySelector('[data-flecha-der]');
      var indiceAtual = 0;

      function irParaIndice(indice) {
        if (thumbnails.length === 0) return;
        if (indice < 0) indice = thumbnails.length - 1;
        if (indice >= thumbnails.length) indice = 0;
        indiceAtual = indice;
        var thumb = thumbnails[indice];
        if (!thumb) return;

        if (thumb.classList.contains('oculto')) {
          thumb.classList.remove('oculto');
        }

        thumbnails.forEach(function(t) { t.classList.remove('activo'); });
        thumb.classList.add('activo');

        if (imagenPrincipal && thumb.dataset.imagenUrl) {
          imagenPrincipal.src = thumb.dataset.imagenUrl;
          imagenPrincipal.alt = thumb.dataset.imagenAlt || '';
        }
        if (imagenBadge) {
          if (thumb.dataset.imagenBadge) {
            imagenBadge.textContent = thumb.dataset.imagenBadge;
            imagenBadge.style.display = '';
          } else {
            imagenBadge.style.display = 'none';
          }
        }
        if (thumbnailsWrapper && thumb.scrollIntoView) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }

      thumbnails.forEach(function(thumb, i) {
        thumb.addEventListener('click', function() {
          irParaIndice(i);
        });
      });

      if (flechaIzq) {
        flechaIzq.addEventListener('click', function() {
          irParaIndice(indiceAtual - 1);
        });
      }
      if (flechaDer) {
        flechaDer.addEventListener('click', function() {
          irParaIndice(indiceAtual + 1);
        });
      }

      var packs = seccion.querySelectorAll('[data-pack]');
      var cta = seccion.querySelector('[data-cta]');

      function getPackSeleccionado() {
        return seccion.querySelector('[data-pack].pack-seleccionado');
      }

      packs.forEach(function(pack) {
        var input = pack.querySelector('input[type="radio"]');
        pack.addEventListener('click', function() {
          packs.forEach(function(p) { p.classList.remove('pack-seleccionado'); });
          pack.classList.add('pack-seleccionado');
          if (input) input.checked = true;

          var imagenPack = pack.dataset.packImagen;
          if (imagenPack && imagenPrincipal) {
            imagenPrincipal.src = imagenPack;
            imagenPrincipal.alt = pack.dataset.packImagenAlt || '';
            thumbnails.forEach(function(t) { t.classList.remove('activo'); });
          }
        });
      });

      if (cta) {
        cta.addEventListener('click', function(e) {
          e.preventDefault();
          if (cta.classList.contains('cargando')) return;

          var seleccionado = getPackSeleccionado();
          if (!seleccionado) {
            console.warn('Ningún pack seleccionado');
            return;
          }

          var variantIdRaw = (seleccionado.dataset.packVariant || '').trim();
          var variantId = parseInt(variantIdRaw, 10);
          var cantidad = parseInt(seleccionado.dataset.packQuantity || '1', 10);
          if (cantidad < 1) cantidad = 1;

          if (!variantId || isNaN(variantId)) {
            console.error('Falta el Variant ID en el pack seleccionado. Configúralo en el editor del tema.');
            return;
          }

          cta.classList.add('cargando');

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: cantidad }]
            })
          })
            .then(function(r) {
              return r.json().then(function(data) {
                if (!r.ok) throw data;
                return data;
              });
            })
            .then(function() {
              cta.classList.remove('cargando');
              if (window.CartDrawerLateral && typeof window.CartDrawerLateral.open === 'function') {
                if (typeof window.CartDrawerLateral.refresh === 'function') {
                  window.CartDrawerLateral.refresh();
                }
                window.CartDrawerLateral.open();
              } else {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
              }
            })
            .catch(function(err) {
              cta.classList.remove('cargando');
              console.error('Error añadiendo al carrito:', err);
              alert('No se pudo añadir el producto al carrito. Verifica que el Variant ID es correcto.');
            });
        });
      }

      var faqs = seccion.querySelectorAll('[data-faq]');
      faqs.forEach(function(faq) {
        var toggle = faq.querySelector('[data-faq-toggle]');
        if (toggle) {
          toggle.addEventListener('click', function() {
            faq.classList.toggle('abierto');
          });
        }
      });

      var timerEl = seccion.querySelector('[data-timer]');
      if (timerEl) {
        var horaObjetivo = parseInt(seccion.dataset.timerHora || '23', 10);
        var minutoObjetivo = parseInt(seccion.dataset.timerMinuto || '59', 10);
        function actualizarTimer() {
          var ahora = new Date();
          var objetivo = new Date();
          objetivo.setHours(horaObjetivo, minutoObjetivo, 0, 0);
          if (objetivo < ahora) {
            objetivo.setDate(objetivo.getDate() + 1);
          }
          var diff = objetivo - ahora;
          var horas = Math.floor(diff / (1000 * 60 * 60));
          var minutos = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          timerEl.textContent = horas + ' HOURS ' + minutos + ' MINUTES';
        }
        actualizarTimer();
        setInterval(actualizarTimer, 30000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Slide"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__sliderAntesDespuesIniciado) return;
    window.__sliderAntesDespuesIniciado = true;

    var sliderAtivo = null;
    var jaMoveu = false;

    function actualizarSlider(slider, clientX) {
      var rect = slider.getBoundingClientRect();
      if (rect.width === 0) return;
      var porcentaje = ((clientX - rect.left) / rect.width) * 100;
      if (porcentaje < 0) porcentaje = 0;
      if (porcentaje > 100) porcentaje = 100;
      var imagenAntes = slider.querySelector('[data-imagen-antes]');
      var linea = slider.querySelector('[data-slider-linea]');
      var handle = slider.querySelector('[data-slider-handle]');
      if (imagenAntes) {
        imagenAntes.style.setProperty('clip-path', 'inset(0 ' + (100 - porcentaje) + '% 0 0)', 'important');
      }
      if (linea) {
        linea.style.setProperty('left', porcentaje + '%', 'important');
      }
      if (handle) {
        handle.style.setProperty('left', porcentaje + '%', 'important');
      }
    }

    document.addEventListener('mousedown', function(e) {
      var slider = e.target.closest('[data-slider-antes-despues]');
      if (!slider) return;
      sliderAtivo = slider;
      jaMoveu = false;
      slider.classList.add('arrastrando');
      e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
      if (!sliderAtivo) return;
      jaMoveu = true;
      actualizarSlider(sliderAtivo, e.clientX);
    });

    document.addEventListener('mouseup', function() {
      if (!sliderAtivo) return;
      sliderAtivo.classList.remove('arrastrando');
      sliderAtivo = null;
    });

    document.addEventListener('touchstart', function(e) {
      var slider = e.target.closest('[data-slider-antes-despues]');
      if (!slider || !e.touches[0]) return;
      sliderAtivo = slider;
      jaMoveu = false;
      slider.classList.add('arrastrando');
    }, { passive: true });

    document.addEventListener('touchmove', function(e) {
      if (!sliderAtivo || !e.touches[0]) return;
      jaMoveu = true;
      actualizarSlider(sliderAtivo, e.touches[0].clientX);
    }, { passive: true });

    document.addEventListener('touchend', function() {
      if (!sliderAtivo) return;
      sliderAtivo.classList.remove('arrastrando');
      sliderAtivo = null;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer-lateral"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-cart-drawer]').forEach(function(drawer) {
      if (drawer.dataset.iniciado === 'true') return;
      drawer.dataset.iniciado = 'true';

      var sectionId = drawer.className.match(/cart-drawer-lateral-([^\s]+)/);
      sectionId = sectionId ? sectionId[1] : null;
      var config = (window.CartDrawerConfig && sectionId) ? window.CartDrawerConfig[sectionId] : {};
      if (!config) config = {};

      var itemsWrapper = drawer.querySelector('[data-cart-items]');
      var vacioWrapper = drawer.querySelector('[data-cart-vacio]');
      var footerWrapper = drawer.querySelector('[data-cart-footer]');
      var progresoWrapper = drawer.querySelector('[data-progreso-wrapper]');
      var progresoFill = drawer.querySelector('[data-progreso-fill]');
      var progresoStatus = drawer.querySelector('[data-progreso-status]');
      var totalEl = drawer.querySelector('[data-cart-total]');
      var shippingEl = drawer.querySelector('[data-cart-shipping]');
      var loadingEl = drawer.querySelector('[data-cart-loading]');
      var overlay = drawer.querySelector('[data-cart-overlay]');
      var panel = drawer.querySelector('.cart-drawer-lateral__panel');
      var botonesCerrar = drawer.querySelectorAll('[data-cart-close]');

      function formatearPrecio(cantidad) {
        var valor = (cantidad / 100).toFixed(2);
        var simbolo = config.moneySymbol || '';
        var mapa = { EUR: '€', USD: '$', GBP: '£', BRL: 'R$' };
        var s = mapa[simbolo] || simbolo + ' ';
        if (simbolo === 'EUR') return valor.replace('.', ',') + ' €';
        return s + valor;
      }

      function abrir() {
        drawer.classList.add('abierto');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cart-drawer-abierto');
        cargarCarrito();
      }

      function cerrar() {
        drawer.classList.remove('abierto');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('cart-drawer-abierto');
      }

      function mostrarLoading(v) {
        if (loadingEl) loadingEl.classList.toggle('visible', v);
      }

      function esItemRegalo(item) {
        if (!item) return false;
        if (config.variantRegalo && item.variant_id === config.variantRegalo) return true;
        if (item.properties && (item.properties._gift === 'true' || item.properties._gift === true)) return true;
        return false;
      }

      function renderItems(cart) {
        if (!itemsWrapper) return;
        itemsWrapper.innerHTML = '';

        if (!cart.items || cart.items.length === 0) {
          if (vacioWrapper) vacioWrapper.classList.add('visible');
          if (footerWrapper) footerWrapper.style.display = 'none';
          if (progresoWrapper) progresoWrapper.style.display = 'none';
          return;
        }

        if (vacioWrapper) vacioWrapper.classList.remove('visible');
        if (footerWrapper) footerWrapper.style.display = '';
        if (progresoWrapper) progresoWrapper.style.display = '';

        cart.items.forEach(function(item) {
          var esRegalo = esItemRegalo(item);
          var wrapper = document.createElement('div');
          wrapper.className = 'cart-drawer-lateral__item';
          wrapper.dataset.itemKey = item.key;

          var imagen = item.image ? item.image.replace(/(\.[^./]+)($|\?)/, '_200x$1$2') : '';
          var nombre = item.product_title || item.title;
          var variante = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';

          var mostrarComparePrice = item.compare_at_price && item.compare_at_price > item.final_price;
          var precioFinal = esRegalo ? (config.textoRegaloGratis || 'Free!') : formatearPrecio(item.final_line_price);
          var precioOriginal = '';
          if (esRegalo) {
            precioOriginal = formatearPrecio(item.original_price * item.quantity);
          } else if (mostrarComparePrice) {
            precioOriginal = formatearPrecio(item.compare_at_price * item.quantity);
          }

          var htmlInfo = '';
          htmlInfo += '<a href="' + item.url + '" class="cart-drawer-lateral__item-nombre" data-cart-close-and-navigate>' + nombre + '</a>';
          if (variante) htmlInfo += '<p class="cart-drawer-lateral__item-variante">' + variante + '</p>';

          if (!esRegalo) {
            htmlInfo += '<div class="cart-drawer-lateral__cantidad">';
            htmlInfo += '<button type="button" class="cart-drawer-lateral__cantidad-boton" data-cantidad-menos aria-label="-">−</button>';
            htmlInfo += '<input type="number" class="cart-drawer-lateral__cantidad-input" value="' + item.quantity + '" min="0" data-cantidad-input>';
            htmlInfo += '<button type="button" class="cart-drawer-lateral__cantidad-boton" data-cantidad-mas aria-label="+">+</button>';
            htmlInfo += '</div>';
          } else {
            var textoRegalo = (config.textoRegalo || 'FREE GIFT').replace('{price}', formatearPrecio(item.original_price));
            htmlInfo += '<span class="cart-drawer-lateral__item-gift-badge">';
            htmlInfo += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 12v10H4V12H2V7h20v5h-2zM4 9v1h16V9H4zm7 3H4v8h7v-8zm2 8h7v-8h-7v8zM7.5 8a2.5 2.5 0 0 1 0-5c1.06 0 1.99.62 2.42 1.52L12 6.24l2.08-1.72A2.5 2.5 0 0 1 16.5 3a2.5 2.5 0 0 1 0 5H14v-.11l-2 1.65-2-1.65V8H7.5zm0-2H10V5.5A1 1 0 0 0 8.5 5a1 1 0 0 0-1 1zm6.5 0h1.5a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1V6z"/></svg>';
            htmlInfo += textoRegalo;
            htmlInfo += '</span>';
          }

          var htmlPrecios = '';
          if (precioOriginal) htmlPrecios += '<span class="cart-drawer-lateral__precio-original">' + precioOriginal + '</span>';
          htmlPrecios += '<span class="cart-drawer-lateral__precio' + (esRegalo ? ' cart-drawer-lateral__precio--gratis' : '') + '">' + precioFinal + '</span>';
          if (!esRegalo) {
            htmlPrecios += '<button type="button" class="cart-drawer-lateral__item-remove" data-cart-remove>' + (config.textoRemove || 'Remove') + '</button>';
          }

          wrapper.innerHTML =
            '<a href="' + item.url + '" data-cart-close-and-navigate><img src="' + imagen + '" alt="' + nombre + '" class="cart-drawer-lateral__item-imagen" loading="lazy"></a>' +
            '<div class="cart-drawer-lateral__item-info">' + htmlInfo + '</div>' +
            '<div class="cart-drawer-lateral__item-precios">' + htmlPrecios + '</div>';

          itemsWrapper.appendChild(wrapper);
        });

        vincularEventosItems();
      }

      function vincularEventosItems() {
        itemsWrapper.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var key = btn.closest('[data-item-key]').dataset.itemKey;
            actualizarCantidad(key, 0);
          });
        });

        itemsWrapper.querySelectorAll('[data-cantidad-menos]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var wrapper = btn.closest('[data-item-key]');
            var input = wrapper.querySelector('[data-cantidad-input]');
            var nueva = Math.max(0, parseInt(input.value, 10) - 1);
            actualizarCantidad(wrapper.dataset.itemKey, nueva);
          });
        });

        itemsWrapper.querySelectorAll('[data-cantidad-mas]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var wrapper = btn.closest('[data-item-key]');
            var input = wrapper.querySelector('[data-cantidad-input]');
            var nueva = parseInt(input.value, 10) + 1;
            actualizarCantidad(wrapper.dataset.itemKey, nueva);
          });
        });

        itemsWrapper.querySelectorAll('[data-cantidad-input]').forEach(function(input) {
          input.addEventListener('change', function() {
            var wrapper = input.closest('[data-item-key]');
            var nueva = Math.max(0, parseInt(input.value, 10) || 0);
            actualizarCantidad(wrapper.dataset.itemKey, nueva);
          });
        });
      }

      function actualizarProgreso(cart) {
        if (!progresoFill || !progresoStatus) return;
        var subtotalSinRegalo = 0;
        (cart.items || []).forEach(function(item) {
          if (!esItemRegalo(item)) subtotalSinRegalo += item.final_line_price;
        });
        var umbral = config.umbralEnvio || 0;
        if (umbral <= 0) {
          progresoFill.style.setProperty('width', '100%', 'important');
          progresoFill.classList.add('progreso-completo');
          progresoStatus.textContent = '';
          return;
        }
        var porcentaje = Math.min(100, (subtotalSinRegalo / umbral) * 100);
        progresoFill.style.setProperty('width', porcentaje + '%', 'important');

        if (subtotalSinRegalo >= umbral) {
          progresoFill.classList.add('progreso-completo');
          progresoStatus.textContent = config.textoProgresoConseguido || 'You unlocked free shipping!';
        } else {
          progresoFill.classList.remove('progreso-completo');
          var restante = umbral - subtotalSinRegalo;
          var texto = (config.textoProgresoRestante || 'Add {amount} more for free shipping').replace('{amount}', formatearPrecio(restante));
          progresoStatus.textContent = texto;
        }
      }

      function actualizarTotales(cart) {
        var subtotalSinRegalo = 0;
        (cart.items || []).forEach(function(item) {
          if (!esItemRegalo(item)) subtotalSinRegalo += item.final_line_price;
        });
        if (totalEl) totalEl.textContent = formatearPrecio(cart.total_price);
        if (shippingEl) {
          var umbral = config.umbralEnvio || 0;
          if (umbral > 0 && subtotalSinRegalo >= umbral) {
            shippingEl.textContent = config.textoShippingGratis || 'Free';
            shippingEl.className = 'cart-drawer-lateral__shipping-gratis';
          } else {
            shippingEl.textContent = config.textoShippingCalculado || 'Calculated at checkout';
            shippingEl.className = '';
          }
        }
      }

      function gestionarRegalo(cart) {
        var variantRegalo = config.variantRegalo;
        var umbralRegalo = config.umbralRegalo || 0;
        if (!variantRegalo || umbralRegalo <= 0) return Promise.resolve(cart);

        var subtotalSinRegalo = 0;
        var regaloEnCarrito = null;
        (cart.items || []).forEach(function(item) {
          if (esItemRegalo(item)) regaloEnCarrito = item;
          else subtotalSinRegalo += item.final_line_price;
        });

        if (subtotalSinRegalo >= umbralRegalo && !regaloEnCarrito) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantRegalo, quantity: 1, properties: { _gift: 'true' } }]
            })
          }).then(function(r) { return r.json(); }).then(function() {
            return fetch('/cart.js').then(function(r) { return r.json(); });
          }).catch(function() { return cart; });
        } else if (subtotalSinRegalo < umbralRegalo && regaloEnCarrito) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: regaloEnCarrito.key, quantity: 0 })
          }).then(function(r) { return r.json(); }).catch(function() { return cart; });
        }
        return Promise.resolve(cart);
      }

      function renderizar(cart) {
        renderItems(cart);
        actualizarProgreso(cart);
        actualizarTotales(cart);
      }

      function cargarCarrito() {
        mostrarLoading(true);
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            return gestionarRegalo(cart);
          })
          .then(function(cart) {
            renderizar(cart);
            mostrarLoading(false);
          })
          .catch(function() {
            mostrarLoading(false);
          });
      }

      function actualizarCantidad(key, cantidad) {
        mostrarLoading(true);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: cantidad })
        })
          .then(function(r) { return r.json(); })
          .then(function(cart) { return gestionarRegalo(cart); })
          .then(function(cart) {
            renderizar(cart);
            actualizarBubbleCarrito(cart);
            mostrarLoading(false);
          })
          .catch(function() { mostrarLoading(false); });
      }

      function actualizarBubbleCarrito(cart) {
        var count = cart.item_count || 0;
        document.querySelectorAll('.cart-count-bubble, #cart-icon-bubble .cart-count-bubble').forEach(function(el) {
          var span = el.querySelector('span[aria-hidden]');
          if (span) span.textContent = count;
        });
      }

      if (overlay) {
        overlay.addEventListener('click', cerrar);
      }

      drawer.addEventListener('mousedown', function(e) {
        if (panel && !panel.contains(e.target)) {
          cerrar();
        }
      });

      botonesCerrar.forEach(function(b) { b.addEventListener('click', cerrar); });
      drawer.addEventListener('click', function(e) {
        var link = e.target.closest('[data-cart-close-and-navigate]');
        if (link) { setTimeout(cerrar, 100); }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && drawer.classList.contains('abierto')) cerrar();
      });

      function interceptarClicksCarrito(e) {
        var link = e.target.closest('a[href="/cart"], a[href$="/cart"], #cart-icon-bubble, .header__icon--cart, [data-cart-open]');
        if (!link) return;
        var url = link.getAttribute('href') || '';
        if (url.indexOf('/cart') === -1 && !link.hasAttribute('data-cart-open') && link.id !== 'cart-icon-bubble' && !link.classList.contains('header__icon--cart')) return;
        e.preventDefault();
        abrir();
      }

      document.addEventListener('click', interceptarClicksCarrito);

      document.addEventListener('submit', function(e) {
        var form = e.target;
        if (!form.matches('form[action*="/cart/add"]')) return;
        e.preventDefault();
        var formData = new FormData(form);
        mostrarLoading(true);
        abrir();
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function(r) { return r.json(); })
          .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
          .then(function(cart) { return gestionarRegalo(cart); })
          .then(function(cart) {
            renderizar(cart);
            actualizarBubbleCarrito(cart);
            mostrarLoading(false);
          })
          .catch(function() { mostrarLoading(false); });
      });

      window.CartDrawerLateral = {
        open: abrir,
        close: cerrar,
        refresh: cargarCarrito
      };

      document.addEventListener('cart:refresh', cargarCarrito);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var forms = document.querySelectorAll('.footer-glash__form');
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        var boton = form.querySelector('.footer-glash__submit');
        if (boton) {
          boton.style.opacity = '0.6';
          boton.disabled = true;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
